import { authenticatedFetch } from '../../../shared/utils/authenticatedFetch';
import type { CheckInData } from '../types/taCheckin';

const PROXY_URL =
  import.meta.env.VITE_PROXY_URL ||
  'https://proxy-prod-people-520260363689.europe-west3.run.app';

export async function fetchCheckInData(fresh = false): Promise<CheckInData> {
  const res = await authenticatedFetch(
    `${PROXY_URL}/api/ta-cockpit/checkin${fresh ? '?fresh=1' : ''}`
  );
  if (!res.ok) {
    let detail = `${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) detail = body.error;
    } catch {
      // non-JSON error body — keep the status code
    }
    throw new Error(`Check-in fetch failed: ${detail}`);
  }
  return res.json();
}
